export default class Dictionary<K=string,V=any>{
  keys: K[];
  values: V[];

  constructor(){
    this.keys = [];
    this.values = [];
  }

  append(key:K, value:V):void{
    this.keys.push(key);
    this.values.push(value);
  }

  getList = ():{key:K, value:V}[] => {
    let r:{key:K, value:V}[] = [];
    for (let i = 0; i < this.keys.length; i++) {
      const key = this.keys[i];
      const value = this.values[i];
      r.push({key,value});
    }
    return r;
  }

  getKeys = ():K[] => this.keys
  getValues = ():V[] => this.values
  get = (key:K):(V | undefined) => {
    let index = this.keys.indexOf(key);
    if(index > -1) {
      return this.values[index];
    }
    return undefined;
  }
}